import { createFileRoute } from '@tanstack/react-router';

// relative imports
import AccountingAccountDisabledPage from '../../components/account-management/AccountDisabledPage';
import TaxPreparerAccountDisabledPage from '../../components/account-management/PreparerAccountDisabledPage';
import LoadingPage from '../../components/shared/page-components/LoadingPage';
import { isModuleEnabled } from '../../data/app-config/configs/configUtilities';

function AccountDisabledPage() {
  return isModuleEnabled({ moduleName: 'admin' }) ? (
    <TaxPreparerAccountDisabledPage />
  ) : (
    <AccountingAccountDisabledPage />
  );
}

export const Route = createFileRoute('/_authenticated/disabled')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: AccountDisabledPage,
  staticData: {
    hideSecondaryMenu: true,
  },
});
